import type {
  AudioPlayerError,
  AudioPlayerState,
  PlaybackState,
  QueueContext,
  QueueState,
} from '@/features/AudioPlayer/types';

/**
 * DEFAULT STATES
 * These constants define the initial state for various aspects of the audio player
 */

// Default empty context for the queue - used when no specific source is provided
export const DEFAULT_CONTEXT: QueueContext = {
  source: '',
  sourceType: 'browse',
};

// Default queue state - empty tracks map with no current track selected
export const initialQueueState: QueueState = {
  tracks: new Map(), // No tracks in queue initially
  trackOrder: [], // Empty track order array
  currentIndex: -1, // -1 indicates no track is selected
  context: DEFAULT_CONTEXT,
  history: [], // Tracks navigation history for "back" functionality
  timestamp: 0, // Initial timestamp (no queue has been activated yet)
};

// Initial complete audio player state
export const initialAudioPlayerState: AudioPlayerState = {
  currentQueue: initialQueueState,
  loadedQueues: [],
};

// Default playback state - stopped with no audio loaded
export const initialPlaybackState: PlaybackState = {
  isPlaying: false, // Not playing initially
  currentTime: 0, // Start at 0 seconds
  duration: 0, // No duration until audio is loaded
  buffered: 0, // No buffering initially
  volume: 1, // Full volume by default
  isMuted: false, // Not muted by default
};

// Default error state - no errors initially
export const initialErrorState: AudioPlayerError | null = null;
